export default __webpack_public_path__ + "static/media/12.6e3932d2.jpg";